<template lang="pug">
  .page
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Delete

    .sub-section
      p Are you sure you really wanna do this? We can't get this back after it is gone.
      div.form-field.no-margin
        button.button.button-alert(type="button", @click="confirmDelete") Delete

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'BoardSettingsForm',
  data () {
    return {
      form: {}
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    confirmDelete () {
      this.$DialogBox.open({
        parent: this,
        open: true,
        header: 'Delete Board?',
        message: 'Remember, this can\'t be undone!',
        onConfirm: () => {
          this.deleteBoard()
        }
      })
      return
    },
    deleteBoard () {
      this.$store.dispatch('boards/deleteBoard', this.$route.params.boardSlug)
        .then(() => {
          this.$router.push({name: 'AdminDashboard'})
        })
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
